import type { ValueOf } from "@shared/types"

/** Слой back-handler'а. Чем выше — тем раньше слой получает клик «назад». */
export const BackPriority = {
	PAGE: 0,
	POPUP: 10,
} as const

export type BackPriorityType = ValueOf<typeof BackPriority>
